import React, { Component } from 'react';

class Testimonials extends Component {
  render() {
    if (!this.props.data) return null;

    const { testimonials } = this.props.data;

    return (
      <section id="testimonials">
        <div className="container">
          <h1>What People Say</h1>

          <div className="testimonials-grid">
            {testimonials &&
              testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <p>{testimonial.text}</p>
                  <cite>{testimonial.user}</cite>
                </div>
              ))}
          </div>
        </div>
      </section>
    );
  }
}

export default Testimonials;
